import { Search } from 'lucide-react';

type TableSearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  id?: string;
};

export function TableSearchInput({
  value,
  onChange,
  placeholder = 'Search…',
  className = '',
  id,
}: TableSearchInputProps) {
  const inputId = id ?? 'table-search';

  return (
    <div className={`relative min-w-[12rem] ${className}`.trim()}>
      <label htmlFor={inputId} className="sr-only">
        Search table
      </label>
      <Search
        className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-chrome-label"
        aria-hidden
      />
      <input
        id={inputId}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-lg border border-border bg-surface py-2 pl-9 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-brand/30"
      />
      {value ? (
        <button
          type="button"
          onClick={() => onChange('')}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-sm leading-none text-chrome-label hover:text-foreground-muted"
          aria-label="Clear search"
        >
          ×
        </button>
      ) : null}
    </div>
  );
}
